import { Loader } from '@googlemaps/js-api-loader';

export const Maps = () => {
	// Set our map div from the DOM
	const mapElements = document.querySelectorAll('.js-map');

	// Check for our map instances
	if (mapElements.length) {

		// Set our API key from our ENV
		const loader = new Loader({
			apiKey: process.env.MIX_GOOGLE_MAPS_API
		});

		// Loop over our map instances
		mapElements.forEach((mapElement) => {

			// Setup the map options
			const mapInstance = {
				element: mapElement,
				options: {
					center: {
						lat: mapElement.dataset.lat ? parseFloat(mapElement.dataset.lat) : 0,
						lng: mapElement.dataset.lng ? parseFloat(mapElement.dataset.lng) : 0,
					},
					zoom: 14,
					disableDefaultUI: false,
					styles: [ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ]
				}
			};

			loader
				.load()
				.then((google) => {
					// Create a new map
					const googleMap = new google.maps.Map(mapInstance.element, mapInstance.options);

					// Create a new pin on our map
					new google.maps.Marker({
						position: {
							lat: mapInstance.options.center.lat,
							lng: mapInstance.options.center.lng
						},
						map: googleMap
					});
				})
				.catch((e) => {
					console.log(e);
				});
		});
	}
};
